__turbopack_context__.v({
  "content": "styles-module__Ka3k3q__content",
});
